// extracted by mini-css-extract-plugin
export default {"Header":"LAF3iUJv0s2RlEFX29bS1g==","LogoContainer":"U733mPUeA2BqzfJRrGbmaQ=="};